module.exports = __webpack_public_path__ + "assets/img/16.2e8728b1.png";